import { getPortalUserUsernameByToken } from '@/store/apiModules/portalUser.api'

function initialState() {
  return {
    invitationToken: '',
  }
}

const portalUser = {
  namespaced: true,
  state: initialState,
  mutations: {
    resetStoreData(state) {
      const localState = initialState()
      Object.keys(state).forEach(prop => {
        state[prop] = localState[prop]
      })
    },
    setInvitationToken(state, value) {
      state.invitationToken = value
    },
  },
  actions: {
    async getPortalUserUsernameByToken({ rootState }, token) {
      try {
        const response = await getPortalUserUsernameByToken(rootState.common.apiToken, token)
        if (response) {
          return response
        }
        return null
      } catch (error) {
        console.warn('Error getting portal user username by token:', error)
        return null
      }
    },

    resetStoreData({ commit }) {
      commit('resetStoreData')
    },
  },
}

export default portalUser
